import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconSportsTennis = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconSportsTennis",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M520-378q-97 0-142 11t-77 43L165-188q-11 11-27 11t-29-11q-12-12-12-28t12-29l135-135q31-31 43-77t11-143q0-58 26-114t74-104q91-91 201-103t181 61q72 72 60 182T738-478q-48 48-104 74t-114 26M412-494q47 46 127 34t143-75q64-64 77-143t-35-125q-48-48-125-36t-143 76q-63 63-76 143t32 126M720-40q-66 0-113-47t-47-113 47-113 113-47 113 47 47 113-47 113-113 47m0-80q33 0 57-23t23-57-23-56-57-24-56 24-24 56 24 57 56 23m0-80"
  })
}));